import ListView from "./ListView";
import { FilterSection } from "./FilterSection";
import { useState } from "react";
import { PageFilter } from "../../data/shared";
import { Outlet } from "react-router-dom";
import { AddAdminModal } from "./AddAdminModal";
import { EditAdminModal } from "./EditAdminModal";
import { useFilter } from "../../hooks/useFilter";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

export function AdminScreen() {
  const [filter, setFilter] = useFilter<PageFilter>({ page: 1, search: "", size: 10 });
  useDocumentTitle("Administrators");
  const handleFilter = (params) => {
    setFilter((prev) => ({ ...prev, ...params }));
  };

  return (
    <>
      <div>
        <FilterSection filter={filter} handleSearch={handleFilter} />
        <ListView filter={filter} handleFilter={handleFilter} />
        <Outlet />
      </div>
    </>
  );
}

export const adminRoutes = () => ({
  path: "admins",
  element: <AdminScreen />,
  children: [
    { path: "add", element: <AddAdminModal /> },
    { path: ":adminId/edit", element: <EditAdminModal /> },
  ],
});
